// Survey Form shows a form for user to add input
import React, {Component} from 'react';
import { reduxForm, Field } from 'redux-form'; // redux form passes data to redux, Field renders any type of html inputs
import { Link } from 'react-router-dom';
import SurveyField from './SurveyField';
import { validateEmails } from '../../utils/validateEmails'
import formFields from './formFields';

class SurveyForm extends Component {

    // renderFields() { // refactor for array of Fields
    //     return (
    //         <div>
    //             <Field label='Survey Title' type='text' name='title' component={SurveyField} />
    //             <Field label='Subject Line' type='text' name='subject' component={SurveyField} />
    //             <Field label='Email Body' type='text' name='body' component={SurveyField} />
    //             <Field label='Recipient List' type='text' name='emails' component={SurveyField} />
    //         </div>
    //     )
    // }

    renderFields() {
        return (
            <div>
                {formFields.map(field => {
                    return <Field label={field.label} type='text' name={field.name} component={SurveyField} key={field.name}/> 
                })}
            </div>
        )
    }

    render(){
        return (
            <div>
                <form onSubmit={this.props.handleSubmit(this.props.onSurveySubmit)}>
                    {this.renderFields()}
                    <Link to="/surveys" className="red btn-flat white-text">
                        Cancel
                    </Link>
                    <button type='submit' className='teal btn-flat right white-text'>
                        Next
                        <i className='material-icons right'>done</i>
                    </button>
                </form>
            </div>
        )
    }
}

function validate(values) {
    const errors = {};

    // if (!values.title) {  // refactor validate ifs for array for each again
    //     errors.title = 'You must provide a title';
    // }
    // if (!values.subject) {
    //     errors.subject = 'You must provide a subject';
    // }

    errors.recipients = validateEmails(values.recipients || '')

    formFields.forEach(field => {
        if (!values[field.name]) {
            errors[field.name] = 'You must provide a value';
        }
    });



    return errors; // if error object is empty in validate, redux form will proceed further with form
}

export default reduxForm({
    //validate: validate, same as validate
    validate,
    form: 'surveyForm',
    destroyOnUnmount: false // we keep values if user comes back to surveyForm
})(SurveyForm);